import elasticsearch from 'elasticsearch'
import queryString from 'query-string'
import {
  getLanguageCol,
  trimLinkText,
  stripHtmlTags
} from '../../helpers/utils'
import { getParam } from '../../helpers/parameters'

export const buildQuery = (query, langId) => {
  query = luceneEscape(query)

  const queryObject = {
    query: {
      bool: {
        disable_coord: true,
        should: [
          {
            function_score: {
              query: {
                bool: {
                  should: [
                    {
                      constant_score: {
                        filter: {
                          match: {
                            [getLanguageCol(
                              'classification',
                              langId,
                              true
                            )]: query
                          }
                        },
                        boost: 3
                      }
                    },
                    {
                      function_score: {
                        query: {
                          match_phrase: {
                            [getLanguageCol('heading', langId, true)]: query
                          }
                        },
                        boost: 2
                      }
                    },
                    { match: { device: query } }
                  ]
                }
              },
              boost: 12
            }
          },
          { term: { device: 'general' } },
          {
            query_string: {
              query,
              default_field: getLanguageCol('heading', langId, true),
              minimum_should_match: '95%',
              boost: 6
            }
          },
          {
            query_string: {
              query,
              default_field: getLanguageCol('heading', langId, true),
              minimum_should_match: '2',
              boost: 4
            }
          },
          {
            query_string: {
              query,
              default_field: getLanguageCol('heading', langId, true),
              boost: 2
            }
          }
        ],
        must: [
          {
            match: {
              [getLanguageCol('all_content', langId, true)]: {
                query,
                minimum_should_match: '3<-75% 9<-85%'
              }
            }
          }
        ],
        filter: {
          bool: {
            should: [],
            must: [{ term: { language: 1 } }, { term: { deleted: 0 } }]
          }
        }
      }
    },
    collapse: { field: 'pk' },

    stored_fields: [
      getLanguageCol('heading', langId, true),
      getLanguageCol('description', langId, true)
    ],

    highlight: buildHighlightQuery(query, langId)
  }

  return queryObject
}

export const buildSuggestionQuery = (query, langId, options = {}) => {
  query = luceneEscape(query)
  return {
    size: 0,
    query: {
      bool: {
        must: [
          {
            multi_match: {
              query,
              fields: [
                `${getLanguageCol('phrase_starts_with', langId, true)}1.75`,
                'heading_bigrams_1',
                getLanguageCol('term_starts_with', langId, true)
              ],
              minimum_should_match: '4<-85% 6<-95%',
              fuzziness: options.fuzziness ? 'AUTO' : undefined
            }
          }
        ],
        filter: {
          bool: {
            must: [{ term: { language: 1 } }, { term: { deleted: 0 } }]
          }
        }
      }
    },
    aggs: {
      headings: {
        terms: {
          field: getLanguageCol('suggestion', langId, true),
          order: { max_score: 'desc' }
        },
        aggs: {
          max_score: {
            max: {
              script: {
                lang: 'painless',
                inline: '_score'
              }
            }
          }
        }
      }
    }
  }
}

export const buildHighlightQuery = (query, langId) => ({
  fields: {
    [getLanguageCol('heading', langId, true)]: { number_of_fragments: 0 },
    [getLanguageCol('description', langId, true)]: {highlight_query: {
      match: {
        [getLanguageCol('description', langId, true)]: luceneEscape(query)
      }
    }}
  }
})

export const client = async path => {
  const [academyApiUrl, academyApiToken] = await Promise.all([
    getParam('academyApiUrl'),
    getParam('academyApiToken')
  ])

  const queryString = window.location.search
  const urlParams = new URLSearchParams(queryString)
  const searchUrl = urlParams.has('customer-override') ? `${academyApiUrl.substr(0, academyApiUrl.lastIndexOf("/"))}/v1` : `${academyApiUrl}`

  const url = new URL(searchUrl)
  return new elasticsearch.Client({
    host: {
      host: url.hostname,
      protocol: url.protocol,
      port: url.port || (url.protocol.includes('https') ? '443' : '80'),
      path: `${url.pathname.replace(/\/$/, '')}/${path}`,
      headers: { Authorization: `Bearer ${academyApiToken}` }
    }
  })
}

/* eslint-disable no-useless-escape */
const luceneEscape = str =>
  str.replace(/([!\/\*\+&\|\(\)\[\]\{\}\^~\?:"])/g, '\\$1')



// WEBPACK FOOTER //
// ./src/containers/ESSearch/helpers.js